// extracted by mini-css-extract-plugin
module.exports = {"default":"countryFlag_default_2oP4Fpa","label":"countryFlag_label_1X0bX8y"};